<template>
  <div class="login-form-container">
    <div class="from_box verify_auth_box">
      <VerificationComponent
        ref="verification"
        :dialogVisible.sync="verificationVisibility"
        :usedAuthTypes="usedAuthTypes"
        @updateState="updateState"
        action="login"
      />
    </div>
  </div>
</template>
<script>
import VerificationComponent from '@/components/security/VerificationComponent.vue';
import helper from '@/util/signinHelper.js';
export default {
  name: 'VerifyAuthentication',
  components: { VerificationComponent },
  mixins: [],
  data() {
    return {
      usedComponent: null,
      verificationVisibility: false
      // usedAuthTypes: []
    };
  },
  computed: {},
  mounted() {
    // this.usedAuthTypes = this.$store.state.common.checkedAuthStatus.filter(
    //   item => item.path == '/verifyAuthentication' && !item.authenticated
    // );
    if (this.usedAuthTypes.length > 0) {
      this.verificationVisibility = true;
    } else {
      this.updateState(null);
    }
  },
  computed: {
    usedAuthTypes() {
      return (
        this.$store.state.common.checkedAuthStatus.filter(
          item => item.path == '/verifyAuthentication' && !item?.authenticated
        ) || []
      );
    }
  },
  watch: {
    usedAuthTypes() {
      this.$forceUpdate();
    }
  },
  methods: {
    async updateState(val) {
      let lackAuthValues = this.$store.state.common.checkedAuthStatus;
      if (val) {
        lackAuthValues = this.$store.state.common.checkedAuthStatus.map(item => {
          return {
            ...item,
            namespace: 'CP_LOGIN',
            authenticated: item.type == val.type ? true : item.authenticated
          };
        });
      }
      if (lackAuthValues.every(item => item.authenticated)) {
        this.$store.state.common.loginCredentials.method == 'register'
          ? helper.register(this.$store.state.common.loginCredentials?.request?.a)
          : this.$store.state.common.loginCredentials.method == 'signInMobile'
          ? helper.signInMobile(
              this.$store.state.common.loginCredentials?.request?.countryCode,
              this.$store.state.common.loginCredentials?.request?.mobileLogin,
              this.$store.state.common.loginCredentials?.request?.passwordLogin
            )
          : helper.signIn(
              this.$store.state.common.loginCredentials?.request?.email,
              this.$store.state.common.loginCredentials?.request?.passwordLogin
            );
      } else {
        //not using path as filter as it might be having same path for totp and email
        const tempObj = lackAuthValues.find(item => !item.authenticated);
        if (tempObj && tempObj?.path != this.$router.currentRoute.path) {
          this.$router.push(tempObj?.path);
        }
      }
      this.$store.commit('common/setCheckedAuthStatus', lackAuthValues);
    }
  }
};
</script>
<style lang="scss" scoped>
#loginClient {
  .right-panel {
    .login-form-container {
      .from_box.verify_auth_box {
        width: 460px;
        /deep/ .el-button {
          width: 100%;
          height: 45px;
          font-size: 16px;
          font-weight: 400;
          margin-top: 20px;
        }
        @media (max-width: 430px) {
          width: 100%;
        }
      }
    }
  }
}
</style>
